import { type ILanguageType } from '@mahawi/eshop-common/src/types';
import { createSlice } from '@reduxjs/toolkit';

import { type ILanguageState } from './types';

export const preloadedState: ILanguageState = {
  languages: undefined,
  languageType: undefined,
};

const move = (
  type: string,
  languages: ILanguageType[],
  languageCode?: string,
): ILanguageType => {
  const index: number = languages.findIndex(
    (language: ILanguageType): boolean => language.code === languageCode,
  );
  const size: number = languages.length;

  let nextIndex: number = 0;

  if (type === 'next') {
    nextIndex = index + 1;

    if (nextIndex === size) {
      nextIndex = 0;
    }
  }

  if (type === 'previous') {
    nextIndex = index - 1;

    if (nextIndex < 0) {
      nextIndex = size - 1;
    }
  }

  return languages[nextIndex];
};

const languageSlice = createSlice({
  name: 'Language',
  initialState: preloadedState,
  reducers: {
    setLanguage: {
      reducer(state, action: { payload: { languageType: ILanguageType } }) {
        state.languageType = action.payload.languageType;
      },
      prepare(languageType: ILanguageType) {
        return { payload: { languageType } };
      },
    },
    nextLanguage(state) {
      if (state.languages) {
        state.languageType = move(
          'next',
          state.languages,
          state.languageType?.code,
        );
      }
    },
    previousLanguage(state) {
      if (state.languages) {
        state.languageType = move(
          'previous',
          state.languages,
          state.languageType?.code,
        );
      }
    },
  },
});

export const { setLanguage, nextLanguage, previousLanguage } =
  languageSlice.actions;
export default languageSlice.reducer;
